import React from "react";
import GlobalBreadcrumbs from "../../components/global/GlobalBreadcrumbs";
import WrapperSection from "../../components/global/WrapperSection";
import FormTestimonialSection from "../../components/testimonials/FormTestimonialSection";
import { useGetTestimonialSection } from "../../hooks/testimonials/useGetTestimonialSection";
import { useUpdateTestimonialSection } from "../../hooks/testimonials/useUpdateTestimonialSection";

const TestimonialSection = () => {
    const { testimonialSection, isLoading: isFetching } = useGetTestimonialSection();
    const { mutate, isPending: isUpdating } = useUpdateTestimonialSection();

    const handleSubmit = (data) => {
        mutate(data);
    };

    if (isFetching) {
        return null;
    }

    return (
        <WrapperSection>
            <GlobalBreadcrumbs />
            <FormTestimonialSection
                currentData={testimonialSection}
                onSubmit={handleSubmit}
                isLoading={isUpdating}
            />
        </WrapperSection>
    );
};

export default TestimonialSection;
